import { convertWidth } from './convertWidth';
export function convertWidthToPPM(peaks, frequency) {
    return convertWidth(peaks, { frequency, convertTo: 'ppm' });
}
//# sourceMappingURL=convertWidthToPPM.js.map